<template>
  <v-layout row align-center>
    <v-flex
      px-1
      py-1
      shrink
      v-if="bookingForm.booking.state == null || bookingForm.booking.state == 'booked'"
    >
      <SelectableDriverInput
        v-model="bookingForm.booking.preassigned_driver"
        :error="bookingForm.errors.preassigned_driver"
        label="Preassign Trip"
        :bookingForm="bookingForm"
      ></SelectableDriverInput>
    </v-flex>
    <v-flex px-1>
      <IconToggle
        @input="function(input) {bookingForm.booking.manual_dispatch = input }"
        v-model="bookingForm.booking.manual_dispatch"
        :disabled="bookingIsCompletedOrCancelled"
        text="M"
      ></IconToggle>
    </v-flex>
  </v-layout>
</template>

<script>
import SelectableDriverInput from "@/components/widget/input/SelectableDriverInput.vue";
import IconToggle from "@/components/widget/input/IconToggle.vue";

export default {
  name: "BookingDispatchInput",
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    IconToggle,
    SelectableDriverInput
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    preassignedDriverError: {
      cache: false,
      get: function() {
        return this.bookingForm.errors.preassigned_driver;
      }
    },
    bookingIsNotBooked() {
      return this.bookingForm.booking.state == null;
    },
    bookingIsCancelled() {
      return this.bookingForm.booking.state == "cancelled";
    },
    bookingIsCompletedOrCancelled() {
      return (
        this.bookingForm.booking.state == "completed" ||
        this.bookingForm.booking.state == "cancelled"
      );
    }
  },
  methods: {
    updateFinalCosts: function() {
      this.$emit("updateFinalCosts", null);
    },
    changePaymentTypeToCard: function(card) {
      console.log("CHANGE PAYMENT TYPE TO CARD");
      this.bookingForm.changePaymentType("card", card);
    },
    changePaymentType: function(paymentType) {
      this.bookingForm.changePaymentType(paymentType, null);
    },
    changePromocode: function(promocode) {
      this.bookingForm.changePromocode(promocode);
    },
    changeAdditionalCharge: function(additionalCharge) {
      this.bookingForm.additional_charge = additionalCharge;
      this.bookingForm.getCostEstimate();
    },
    changeFinalCost: function(finalCost) {
      this.bookingForm.booking.final_cost = finalCost;
      this.bookingForm.booking.fixedCostType = this.bookingForm.FIXED_COST_DISPATCHER();
    },
    changeFinalCostDriver: function(finalCostDriver) {
      this.bookingForm.booking.final_cost_driver = finalCostDriver;
      this.bookingForm.booking.fixedCostDriverType = this.bookingForm.FIXED_COST_DISPATCHER();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.disabled-panel {
  pointer-events: none;
}

.change-cost-panel {
  background-color: #e3f2fd;
}
</style>
